<l-list-container
  class="courses-list-table"
  [size]="limit"
  [page]="page"
  [data]="data"
  [sort]="sort"
  [total]="total"
  [isLoading]="isLoading"
  (onPage)="pageChange.emit($event)"
  (onSort)="sortChange.emit($event)"
>
  <ng-template #header>
    <th lSortable="title">Nome</th>
    <th lSortable="description">Descrição</th>
    <th lSortable="status">Status</th>
    <th lSortable="category.name">Categoria</th>
    <th lSortable="createdAt">Criado em</th>
    <th lSortable="updatedAt">Última atualização</th>
    <th class="w-12">Ações</th>
  </ng-template>

  <ng-template #body let-course>
    <td class="align-top">
      <span class="font-medium text-lWhite">{{ course.title }}</span>
    </td>

    <td class="align-top">
      <span class="block max-w-[460px] text-sm leading-5 text-lGray300">
        {{ course.description || '—' }}
      </span>
    </td>

    <td class="align-top">
      <span
        class="inline-flex min-w-[88px] items-center justify-center rounded-full px-3 py-1 text-sm font-medium"
        [class]="getStatusClass(course.status)"
      >
        {{ getStatusLabel(course.status) }}
      </span>
    </td>

    <td class="align-top">
      <ng-container *ngIf="resolveCategory(course) as category; else noCategory">
        <l-course-category-tag
          [label]="category.name"
          [backgroundColor]="category.color || '#5B55FF'"
          [textColor]="getCategoryTextColor(category.color)"
        />
      </ng-container>
      <ng-template #noCategory>
        <span class="text-lGray400">—</span>
      </ng-template>
    </td>

    <td class="align-top">{{ course.createdAt | date: 'yyyy-MM-dd' }}</td>

    <td class="align-top">{{ course.updatedAt | date: 'yyyy-MM-dd' }}</td>

    <td class="align-top">
      <button
        class="flex h-7 w-7 items-center justify-center rounded text-lGray600 transition-colors hover:bg-lGray700/70 hover:text-lWhite"
        (click)="rowMenu.toggle($event)"
      >
        <l-icon icon="more_vert" />
      </button>

      <l-modal-actions #rowMenu [actions]="getRowActions(course)" />
    </td>
  </ng-template>
</l-list-container>
